import type { StaticImageData } from 'next/image';
import Image from 'next/image';
import fallbackImage from 'public/images/common/fallbackImage.svg';
import { useState } from 'react';

const myLoader = ({ src, width, quality }: { src: string; width: number; quality?: number }) => {
  const patterns = [
    {
      s3: 'wa-kaimono-web-tokyo-development\\.s3(?:-ap)?\\.ap-northeast-1\\.amazonaws\\.com',
      cloudfront: 'https://dd8f8rnqzvuk.cloudfront.net/'
    },
    {
      s3: 'wa-kaimono-backend-tokyo-production\\.s3(?:-ap)?\\.ap-northeast-1\\.amazonaws\\.com',
      cloudfront: 'https://d1git0hj90x82c.cloudfront.net/'
    }
  ];

  for (const pattern of patterns) {
    const s3Pattern = new RegExp(`(https?:\\/\\/(${pattern.s3})\\/)(.+)`);
    const matches = src.match(s3Pattern);
    if (matches && matches[3]) {
      // S3 URLをCloudFront URLに置き換える
      src = `${pattern.cloudfront}${matches[3]}`;
      break;
    }
  }

  return `${src}?w=${width}&q=${quality || 75}`;
};

/**
 * @refs
 * https://dev.to/elisabethleonhardt/configure-fallback-images-in-react-and-nextjs-54ej
 * https://solutions-image-fallback.vercel.app/
 */

export const NextImage = ({
  src,
  alt,
  width,
  height,
  objectFit = 'contain',
  layout,
  className,
  onClick
}: {
  src: string | StaticImageData | null;
  alt: string;
  width?: number;
  height?: number;
  objectFit?: 'contain' | 'cover' | 'fill';
  layout?: 'responsive' | 'fill';
  className?: string;
  onClick?: () => void;
}) => {
  // srcがnullの可能性があり、その場合最初にimageErrorをtrueにしないと描画時点でエラーになってしまう
  const [imageError, setImageError] = useState<boolean>(src === null);
  return (
    <>
      {width && height ? (
        <Image
          loader={myLoader}
          src={imageError ? fallbackImage : src}
          alt={alt}
          width={width}
          height={height}
          layout={layout}
          objectFit={objectFit}
          onClick={onClick}
          className={className}
          onError={() => setImageError(true)}
        />
      ) : (
        <Image
          loader={myLoader}
          src={imageError ? fallbackImage : src}
          alt={alt}
          layout={'fill'}
          objectFit={objectFit}
          onClick={onClick}
          className={className}
          onError={() => setImageError(true)}
        />
      )}
    </>
  );
};
